import React from 'react'
import styles from './TimeManagementBox.less'
// import PropTypes from 'prop-types'
export class TimeManagementBox extends React.Component {
  // static propTypes = {
  //   onClickTime: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  //   timeText: PropTypes.string.isRequired,
  //   checked: PropTypes.bool.isRequired
  // }

  render () {
    const { onClickTime, timeText, checked } = this.props
    return (
      <div className={styles.grid} >
        <div className={styles.gridside}>Clock In</div>
        <div className={styles.gridstack} >
          <div key='togglewrap' className={styles.togglewrap} style={{ '--theme-primary-color': `${timeText.length > 0 ? checked ? '#00B050' : '#FF0000' : 'clear'}` }} data-tip={timeText}>
            <label className={styles.switchwrap} >
              <input type="checkbox" onClick={onClickTime} checked={checked}/>
              <div className={styles.switch}>
              </div>
            </label>
          </div>
        </div>
        <div className={styles.gridside}>Clock Out</div>
      </div>
    )
  }
}
